import React from 'react'
import { Box, IconButton } from '@mui/material'
import { Icon } from 'src/components/atoms'
import BreadcrumbsPipe, { Path } from 'src/components/molecules/BreadcrumbsPipe'
import Guide from 'src/components/molecules/Guide'
import style from './styles.module.scss'

export type StartEditCalculationProps = {
  breadcrumbs: Path[]
  onClickClose: () => void
  onClickForward: () => void
}

const StartEditCalculation: React.StyledFC<StartEditCalculationProps> = ({
  breadcrumbs,
  onClickClose,
  onClickForward,
}: StartEditCalculationProps) => {
  const buttons = [
    {
      index: 0,
      title: 'すすむ',
      onClick: onClickForward,
    },
  ]

  return (
    <Box className={style.root}>
      <Box className={style.header} component="header">
        <BreadcrumbsPipe className={style.breadcrumb} paths={breadcrumbs} />
        <Box className={style.closeButtonWrapper}>
          <IconButton
            className={style.closeButton}
            onClick={onClickClose}
            size="large"
          >
            <Icon icon="close" />
          </IconButton>
        </Box>
      </Box>
      <Box className={style.contentWrapper}>
        <Guide
          message={`利用開始に必要な準備を\n行っていきましょう。`}
          description="各テナントごとの独自レシート設定を行うことで売上報告ツールが利用開始できます。"
          buttons={buttons}
          icon="pointRight"
        />
      </Box>
    </Box>
  )
}

export default StartEditCalculation
